import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import Highcharts from "highcharts/highcharts.js";
import highchartsMore from "highcharts/highcharts-more.js"
import solidgauge from "highcharts/modules/solid-gauge.js";
import HighchartsReact from "highcharts-react-official";
import './ActivityTracker.css';
import { IconButton, IconMenu, MenuItem } from 'material-ui';
import MoreVertIcon from 'material-ui/svg-icons/navigation/more-vert';

class StepSpline extends Component {
    constructor(props) {
        super(props);
        this.state = {
            ChartOptions: {
                chart: {
                    type: 'areaspline',
                    height: '50%',
                    backgroundColor: 'none',
                },                
                title: {
                    text: null,
                },
                subtitle: {
                    text: null,
                },

                xAxis: {
                    type: 'datetime',
                    labels: {
                        overflow: 'justify'
                    }
                },

                yAxis: {
                    title: {
                        text: null
                    },
                    labels: {
                        enabled:false,
                        overflow: 'justify'
                    },
                    minorGridLineWidth: 0,
                    gridLineWidth: 0,
                    alternateGridColor: null,
                },

                tooltip: {
                    enabled: false,
                },

                plotOptions: {
                    areaspline: {                        
                        lineColor:window.muiTheme.palette.primary1Color,
                        fillColor: {
                            linearGradient: [0, 0, 0, 300],
                            stops: [
                                [0, window.muiTheme.palette.primary1Color],
                                [1, Highcharts.color(window.muiTheme.palette.primary1Color).setOpacity(0).get('rgba')]
                            ]
                        },
                        lineWidth: 8,
                        marker: {
                            enabled: false
                        },
                    },
                },

                series: [{
                    showInLegend: false,
                    name: null,
                    pointStart:this.props.startDate,
                    pointInterval: 24*60*60*1000,
                    data: this.props.data.map((v, i) => v.Value),
                }]

            }
        }
    }

    render(){

        return (
            <div className={'activity-history-container'} style={{backgroundColor:`${window.muiTheme.palette.primary1Color}26`}}>
                <div className={'activity-chart-header-container'} >
                    <span className={'activity-chart-header'}>Step History</span>
                    <div className={'activity-chart-elipses'}>
                        {/* <IconMenu iconButtonElement={<IconButton><MoreVertIcon /></IconButton>}>
                            <MenuItem primaryText={'Change Date Range'} />
                        </IconMenu> */}
                    </div>
                </div>
                <HighchartsReact
                    highcharts={Highcharts}
                    options={this.state.ChartOptions}
                />
            </div>
        )
    }
}

export default StepSpline;


// WEBPACK FOOTER //
// ./src/Components/ActivityTracker/StepSpline.js